import { render } from "./AppearObject.vue?vue&type=template&id=7bec40b5&ts=true"
import script from "./AppearObject.vue?vue&type=script&lang=ts"
export * from "./AppearObject.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__